import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../../query/query-ids'
import { removeElementalTag } from '~~/src/api/tags'
import type { TagData } from '~~/src/api/tags'
import type { GetArg } from '~~/src/types/utils'

type FnType = typeof removeElementalTag
type Args = GetArg<typeof removeElementalTag>
export interface RemoveElementalTagArgs {elementalId: Args[0]; tagId: Args[1]}

export const useRemoveElementalTagMutation = () => {
  const queryClient = useQueryClient()
  return useMutation<Awaited<ReturnType<FnType>>, Error, RemoveElementalTagArgs>({
    mutationKey: ['create-tag'],
    mutationFn: async ({ elementalId, tagId }) => {
      return await removeElementalTag(elementalId, tagId)
    },
    onMutate({ tagId, elementalId }) {
      queryClient.setQueriesData<TagData[]>({
        queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
        exact: false,
        type: 'all',
      }, (old) => {
        if (!old)
          return old
        return old.filter(tag => tag.id !== tagId)
      })
    },
    onError: (_, { elementalId }) => {
      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
        exact: false,
        type: 'all',
      })
      if (elementalId) {
        queryClient.refetchQueries({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
          exact: false,
          type: 'all',
        })
      }
    },
    onSuccess: (result, { elementalId }) => {
      if (!result)
        return
      queryClient.invalidateQueries({
        queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
        exact: false,
        type: 'all',
      })
    },
  })
}
